import { render, staticRenderFns } from "./ModalLuxInfo.vue?vue&type=template&id=16be4da1&scoped=true"
import script from "./ModalLuxInfo.vue?vue&type=script&lang=js"
export * from "./ModalLuxInfo.vue?vue&type=script&lang=js"
import style0 from "./ModalLuxInfo.vue?vue&type=style&index=0&id=16be4da1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16be4da1",
  null
  
)

export default component.exports